import { Button, Container, Nav, Navbar } from "react-bootstrap";
import logo from "../assets/images/icon.png"
import { clearLoginGameInfo, getLocalStorage, removeLocalStorage } from "../utils/localStorage";
import { STORAGE_KEY } from "../constants/storageKeys";
import { useNavigate } from "react-router-dom";
import { SCREEN_ROUTER } from "../constants/screenRouter";
import { useEffect, useRef, useState } from "react";
import useIsLoginAccountStore from "../hooks/useLoginAccount";
import { checkAccount } from "../services/authService";
import useIsUpdateCookie from "../hooks/useIsUpdateCookie";
import nextScreen from "../utils/navigateScreen";

const Header = () => {
    const [navbarOpen, setNavbarOpen] = useState(false);
    const { isLoginAccount, setIsLoginAccount } = useIsLoginAccountStore();
    const [refreshingCookie, setRefreshingCookie] = useState(false);
    const { isUpdateCookie, setIsUpdateCookie } = useIsUpdateCookie()
    const navigate = useNavigate()
    const handleLogout = () => {
        clearLoginGameInfo();
        removeLocalStorage(STORAGE_KEY.LOGIN_TOKEN);
        setNavbarOpen(false);
        navigate(SCREEN_ROUTER.LOGIN_TOKEN);
    }
    const handleClearCookie = () => {
        clearLoginGameInfo();
        setNavbarOpen(false);
        navigate(SCREEN_ROUTER.LOGIN_METHOD);
    }

    const handleRefreshCookie = () => {
        const userInfo = getLocalStorage(STORAGE_KEY.USER_INFO);
        setRefreshingCookie(true);
        clearLoginGameInfo();
        checkAccount(userInfo.Username, userInfo.password).then((res) => {
            if (res === true) {
                setIsUpdateCookie(!isUpdateCookie);
            } else if (res === -1) {
                navigate(SCREEN_ROUTER.LOGIN_TOKEN);
            }
        }).finally(() => {
            setNavbarOpen(false);
            setRefreshingCookie(false);
        })
    }

    const handleClearPass = () => {
        setIsLoginAccount(false);
        handleClearCookie();
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (event.target.closest(".navbar") === null) {
                setNavbarOpen(false);
            }
        };
        const userInfo = getLocalStorage(STORAGE_KEY.USER_INFO);
        if (userInfo?.password != null) setIsLoginAccount(true);
        else setIsLoginAccount(false);

        // Thêm sự kiện click vào document
        document.addEventListener("click", handleClickOutside);

        return () => {
            // Dọn dẹp sự kiện khi component bị unmount
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <Navbar bg="light" expand="lg" className="py-1">
            <Container fluid>
                {/* Logo & Brand Name */}
                <Navbar.Brand href={SCREEN_ROUTER.LOGIN_TOKEN} className="d-flex align-items-center">
                    <img
                        src={logo}
                        alt="Auto Ngọa Long"
                        className="d-inline-block align-text-top"
                        width='30'
                        height='30'
                    />
                    <span className="ms-2 d-none d-lg-inline text-primary fs-6">Auto Ngọa Long</span>
                </Navbar.Brand>

                {/* Toggle button for mobile */}
                <Navbar.Toggle
                    aria-controls="navbar-nav"
                    onClick={() => setNavbarOpen(!navbarOpen)}  // Toggle khi click
                />

                {/* Navbar Items */}
                <Navbar.Collapse id="navbar-nav" className="justify-content-end" in={navbarOpen}>
                    <Nav className="d-none d-lg-flex align-items-center">
                        {!isLoginAccount && <Button id="btn-clear-cookie-header" variant="outline-success" className="me-5" onClick={handleClearCookie}>
                            Clear Cookie
                        </Button>}
                        {isLoginAccount && <Button id="btn-refresh-cookie-header" variant="outline-success" className="me-5" disabled={refreshingCookie} onClick={handleRefreshCookie}>
                            Refresh Cookie
                        </Button>}
                        {isLoginAccount && <Button id="btn-clear-pass-header" variant="outline-success" className="me-5" onClick={handleClearPass}>
                            Clear Password
                        </Button>}
                        <Button id="btn-logout-header" variant="outline-danger" className="me-2" onClick={handleLogout}>
                            Log Out
                        </Button>
                    </Nav>

                    {/* Mobile: Căn giữa */}
                    <Nav className="d-flex d-lg-none flex-column align-items-center w-100 mt-1 gap-2">
                        {!isLoginAccount && <Button id="btn-clear-cookie-header" variant="outline-success" className="w-75 fs-6" onClick={handleClearCookie}>
                            Clear Cookie
                        </Button>}
                        {isLoginAccount && <Button id="btn-refresh-cookie-header" variant="outline-success" className="w-75 fs-6" disabled={refreshingCookie} onClick={handleRefreshCookie}>
                            Refresh Cookie
                        </Button>}
                        {isLoginAccount && <Button id="btn-clear-pass-header" variant="outline-success" className="w-75 fs-6" onClick={handleClearPass}>
                            Clear Password
                        </Button>}
                        <Button id="btn-logout-header" variant="outline-danger" className="w-75 fs-6" onClick={handleLogout}>
                            Log Out
                        </Button>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;